import React from 'react';
import LayoutContext from '../../Layouts/LayoutContext';
import {hasValue} from '../../../utils/utils';


function SMCModalBody({
    children,
    labelWidth,
    inputWidth,
    lineHeight,
    style
}) {
    return (
        <>
        <LayoutContext.Provider
            value={{
                labelWidth: hasValue(labelWidth) ? labelWidth : 180,
                inputWidth: hasValue(inputWidth) ? inputWidth : 200
            }}
        >
            <div className="WizContent" style={{ lineHeight: lineHeight || undefined, ...style }}>
                { children }
            </div>
        </LayoutContext.Provider>
        </>
    );
}

export default SMCModalBody;